import React, { Component } from "react";
import {
  Select,
  Table,
  Button,
  Tooltip,
  Modal,
  message,
  Input,
  Image,
  Tabs,
  Row,
  Col,
  Radio
} from "antd";
import { Link } from "react-router-dom";
// import styles from "./complainView.module.scss";
import jwtDecode from "jwt-decode";
import { CopyOutlined } from "@ant-design/icons";
import Loader from "../loader";
import Fetch from "../../utils/fetch";
import CrewTicketSearch from "../../components/crewTicketSearch";
import moment from "moment";
import {
  EditOutlined,
  PlusCircleOutlined,
  PlayCircleOutlined
} from "@ant-design/icons";
const { Option } = Select;
const { TabPane } = Tabs;
const wordBreakStyle = { wordBreak: "breakWord" };

const serviceNameFetched = [],
  faultOfFetched = [],
  resolvedByFetched = [];
function msToTime(duration) {
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  let days = Math.floor(duration / (1000 * 60 * 60 * 24));
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return days + " days: " + hours + " hrs :" + minutes + " min";
}

const callDetailsCol = [
  {
    title: "Time",
    dataIndex: "time",
    width: "10%",
    key: "time"
  },
  {
    title: "Duration",
    dataIndex: "duration",
    width: "10%",
    key: "duration"
  },
  {
    title: "Status",
    dataIndex: "status",
    width: "10%",
    key: "status"
  },
  {
    title: "Recording",
    dataIndex: "recording",
    width: "10%",
    key: "recording",
    render: ({ recording }) => {
      return (
        <Link to={recording} target="_blank">
          <PlayCircleOutlined />
        </Link>
      );
    }
  }
];

const columns = [
  {
    title: "Service Name",
    dataIndex: "serviceName",
    key: "serviceName",
    filterSearch: true,
    filters: serviceNameFetched,
    onFilter: (value, record) => record.serviceName.includes(value),
    width: "10%"
  },
  {
    title: "Raised By",
    dataIndex: "raisedBy",
    key: "raisedBy",
    width: "10%"
  },
  {
    title: "Complain Category",
    dataIndex: "complainCategory",
    key: "complainCategory",
    width: "10%"
  },
  {
    title: "PNR",
    dataIndex: "bookingCode",
    key: "bookingCode",
    width: "10%"
  },
  {
    title: "Seat number",
    dataIndex: "seat",
    key: "seat",
    width: "10%"
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "10%"
  },
  {
    title: "Attachment",
    dataIndex: "attachment",
    key: "attachments",
    width: "14%",
    render: ({ showModal, isAttachmentAvailable }) => {
      return (
        <Button disabled={isAttachmentAvailable} onClick={showModal}>
          Show Attachment
        </Button>
      );
    }
  },
  {
    title: "Details",
    dataIndex: "details",
    key: "details",
    width: "14%",
    render: ({ showModal, isAttachmentAvailable }) => {
      return (
        <Button disabled={isAttachmentAvailable} onClick={showModal}>
          Show Details
        </Button>
      );
    }
  },

  {
    title: "Call Logs",
    dataIndex: "calllogs",
    key: "calllogs",
    width: "10%",
    render: ({ showModal, show, recordingUrl }) => {
      if (recordingUrl) {
        return (
          <div>
            <Button onClick={() => window.open(recordingUrl)}>
              Show Recording
            </Button>
          </div>
        );
      } else {
        return (
          <Button disabled={show} onClick={showModal}>
            Show Logs
          </Button>
        );
      }
    }
  },
  {
    title: "Call",
    dataIndex: "call",
    key: "call",
    width: "14%",
    render: ({ showModal }) => {
      return <Button onClick={showModal}>Connect to marshal</Button>;
    }
  },
  {
    title: "Created On",
    dataIndex: "createdOn",
    key: "createdOn",
    width: "10%"
  },
  {
    title: "TAT",
    dataIndex: "tat",
    key: "tat",
    width: "10%"
  },

  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
    width: "10%",
    render: ({ value, _id, allRemarks, remarksUpdate, serviceId }) => (
      <>
        <EditOutlined
          onClick={() => remarksUpdate({ allRemarks, value, _id, serviceId })}
        />
        <span style={wordBreakStyle}>{value}</span>
      </>
    )
  },
  {
    title: "Marshal remark",
    dataIndex: "marshallRemarks",
    key: "marshallRemarks",
    width: "10%",
    render: ({
      value,
      _id,
      raisedBy,
      allMarshallRemarks,
      marshallRemarksUpdate,
      serviceId
    }) => (
      <>
        <EditOutlined
          onClick={() =>
            marshallRemarksUpdate({
              allMarshallRemarks,
              value,
              _id,
              raisedBy,
              serviceId
            })
          }
        />
        <span style={wordBreakStyle}>{value}</span>
      </>
    )
  },
  {
    title: "CX Team Remarks",
    dataIndex: "customerRemarks",
    key: "customerRemarks",
    width: "12%",
    render: ({
      value,
      _id,
      raisedBy,
      allCustomerRemarks,
      marshallCtxShow,
      serviceId
    }) => (
      <>
        <span style={wordBreakStyle}>{value}</span>
        <br />
        <PlusCircleOutlined
          onClick={() =>
            marshallCtxShow({
              allCustomerRemarks,
              value,
              _id,
              raisedBy,
              serviceId
            })
          }
        />
      </>
    )
  },
  {
    title: "Department",
    dataIndex: "department",
    key: "department",
    width: "10%",
    render: ({ serviceId, department, raisedBy, _id, updateDepartment }) => {
      if (department == "Crew TICKET") {
        return <div>Crew Team</div>;
      } else {
        return (
          <Select
            value={department}
            style={{ width: 120, margin: "0 0.2rem", whiteSpace: "pre-line" }}
            onChange={e =>
              updateDepartment({
                serviceId,
                department: e,
                raisedBy,
                _id
              })
            }
          >
            <Option value="Crew Team">Crew Team</Option>
            <Option value="CX Team">CX Team</Option>
          </Select>
        );
      }
    }
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "12%",
    render: ({
      status,
      raisedBy,
      _id,
      updateStatus,
      serviceId,
      isNotBoarded,
      canEdit
    }) => {
      return (
        <Select
          disabled={canEdit}
          value={status}
          style={{ width: 120, margin: "0 0.2rem", whiteSpace: "pre-line" }}
          onChange={e =>
            updateStatus({
              isNotBoarded,
              status: e,
              raisedBy,
              _id,
              serviceId
            })
          }
        >
          {isNotBoarded ? null : <Option value="REJECTED">REJECTED</Option>}

          <Option value="CLOSED">CLOSED</Option>
          <Option value="INPROGRESS">INPROGRESS</Option>
          <Option value="CREATED">CREATED</Option>
        </Select>
      );
    }
  },
  {
    title: "Fault Attribution",
    dataIndex: "fault",
    key: "fault",
    filterSearch: true,
    filters: faultOfFetched,
    onFilter: (value, record) => record.fault.includes(value),
    width: "10%"
  },
  {
    title: "Resolved By",
    dataIndex: "resolved",
    filterSearch: true,
    filters: resolvedByFetched,
    onFilter: (value, record) => record.resolved.includes(value),
    key: "resolved",
    width: "10%"
  }
];

class complainView extends Component {
  state = {
    loading: true,
    showRemarksEdit: false,
    showSolutionTimeEdit: false,
    minutes: 0,
    hours: 0,
    day: 0,
    showAttachments: false,
    showFrames: false,
    showHeadDetails: false,
    showArrayAttachments: false,
    showFailedAttachments: false,
    attachmentPath: "",
    showLogs: false,
    showCall: false,
    faultModal: false,
    showMarshallCall: false,
    remarkInput: "",
    frameImages: [],
    idsDetails: {},
    modalLoader: true,
    showVideoAttachmentModal: false,
    videoAttachment: null,
    activeKey: "1",
    headcountEvents: [],
    imageAttachment: [],
    showImageModal: false
  };

  async componentDidMount() {
    try {
      const complainResponse = await this.fetchComplain();
      this.setFilterAttributes(complainResponse);
      this.setState({ complainResponse, loading: false });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  }

  setFilterAttributes = complainResponse => {
    serviceNameFetched.length = 0;
    resolvedByFetched.length = 0;
    faultOfFetched.length = 0;
    let serviceNameHashMap = {};
    let resolvedByHashMap = {};
    let faultOfHashMap = {};

    for (let i = 0; i < complainResponse.length; i++) {
      let fetchedData = complainResponse[i];

      serviceNameHashMap[fetchedData.serviceName] = [];

      const resolvedBy = fetchedData.resolved || "NA";
      resolvedByHashMap[resolvedBy] = [];

      const faultOf = fetchedData.fault || "NA";
      faultOfHashMap[faultOf] = [];
    }

    for (let key in serviceNameHashMap) {
      serviceNameFetched.push({ text: key, value: key });
    }

    for (let key in resolvedByHashMap) {
      resolvedByFetched.push({ text: key, value: key });
    }

    for (let key in faultOfHashMap) {
      faultOfFetched.push({ text: key, value: key });
    }
  };

  fetchComplain = async () => {
    try {
      const url = `/bus-tracker/complianSearch`;
      const options = {
        method: "post"
      };
      const response = await Fetch(url, options);
      if (response && Array.isArray(response)) {
        return this.formattedData(response);
      }
      return null;
    } catch (err) {
      console.log(err);
      message.error(err);
    }
  };

  formattedData = response => {
    try {
      let formetedRep = [],
        check = [],
        hashMap = {};
      for (let i = 0; i < response.length; i++) {
        let complains = response[i];
        let latestValue = complains.remarks ? complains.remarks.split("|") : "";
        latestValue = latestValue ? latestValue.filter(obj => obj != "") : "";

        let latestValueMarshallRemark = complains.marshallRemark
          ? complains.marshallRemark.split("|")
          : "";
        latestValueMarshallRemark = latestValueMarshallRemark
          ? latestValueMarshallRemark.filter(obj => obj != "")
          : "";
        let latestValueCtxRemark = complains.customerRemarks
          ? complains.customerRemarks.split("|")
          : "";
        latestValueCtxRemark = latestValueCtxRemark
          ? latestValueCtxRemark.filter(obj => obj != "")
          : "";

        let driverImages = complains.driverPicUri ? complains.driverPicUri : [];

        if (complains.faces) {
          driverImages = driverImages.concat(complains.faces);
        }

        const isAttachmentAvailable =
          complains.attachment ||
          driverImages.length > 0 ||
          (complains.facialUserSession && complains.userId)
            ? false
            : true;

        const complainFormated = {
          key: complains._id,
          _id: complains._id,
          complainCategory: complains.complainCategory,
          description: complains.description,
          createdOn: moment(complains.createdOn).format("LLL"),
          tat: msToTime(complains.tat),
          tatInMillis: complains.tat,
          solTime: moment(complains.solutionTime).format("LLL"),
          add: {
            _id: complains._id,
            solutionTimeUpdate: this.solutionTimeUpdate,
            serviceId: complains.serviceId
          },
          remarks: {
            _id: complains._id,
            value: latestValue[latestValue.length - 1],
            allRemarks: complains.remarks,
            serviceId: complains.serviceId,
            remarksUpdate: this.remarksUpdate
          },
          marshallRemarks: {
            _id: complains._id,
            serviceId: complains.serviceId,
            value:
              latestValueMarshallRemark[latestValueMarshallRemark.length - 1],
            allMarshallRemarks: complains.marshallRemark,
            raisedBy: complains.raisedBy,
            marshallRemarksUpdate: this.marshallRemarksUpdate
          },
          customerRemarks: {
            _id: complains._id,
            serviceId: complains.serviceId,
            value: latestValueCtxRemark[latestValueCtxRemark.length - 1],
            allCustomerRemarks: complains.customerRemarks,
            raisedBy: complains.raisedBy,
            marshallCtxShow: this.marshallCtxShow
          },
          complainComments: complains.complaintName,
          raisedBy:
            complains.complainCategory === "AMENITY COLLECTION" ||
            complains.complainCategory === "DRIVER/RC DETAILS MISMATCH"
              ? "marshal"
              : complains.raisedBy,
          complainRaisedBy: complains.raisedBy,
          serviceName: complains.serviceName,
          serviceId: complains.serviceId,
          seat: complains.seatNumber,
          bookingCode: complains.pnr,
          attachment: {
            isAttachmentAvailable,
            showModal: () =>
              this.showAttachmentModal(
                complains.facialUserSession,
                complains.userId,
                complains.attachment,
                complains._id,
                complains.attachmentType,
                driverImages,
                complains.trip
              )
          },
          details: {
            isAttachmentAvailable:
              complains.attachment ||
              complains.frames ||
              complains.headCountDetails ||
              (complains.facialUserSession && complains.userId)
                ? false
                : true,
            showModal: () =>
              complains.frames
                ? this.showFrameModal(complains.frames, complains)
                : complains.headCountDetails
                ? this.showHeadModal(complains.headCountDetails, complains)
                : this.showCrewModal(
                    complains.facialUserSession,
                    complains.trip,
                    moment(complains.createdOn).format("LLL"),
                    complains._id,
                    complains.livenessConfidence,
                    complains.similarity
                  )
          },
          calllogs: {
            recordingUrl: complains.recordingUrl,
            show: complains.callLogsRestriction,
            showModal: () =>
              this.showLogsModal(
                complains.tripId,
                complains.createdOn,
                complains._id
              )
          },
          call: {
            show: complains.callLogsRestriction,
            showModal: () => this.showCallModal(complains.tripId, complains._id)
          },
          department: {
            serviceId: complains.serviceId,
            updateDepartment: this.updateDepartment,
            raisedBy: complains.raisedBy,
            _id: complains._id,
            department: complains.department
          },
          status: {
            canEdit:
              complains.complainCategory == "NOT BOARDED" &&
              (complains.status == "CLOSED" || complains.status == "REJECTED"),
            isNotBoarded: complains.complainCategory == "NOT BOARDED",
            serviceId: complains.serviceId,
            updateStatus: this.updateStatus,
            status: complains.status,
            raisedBy: complains.raisedBy,
            _id: complains._id
          },
          fault: complains.faultOf || "NA",
          resolved: complains.resolvedBy || "NA"
        };
        let key = `${complains.tripId}`;
        if (hashMap[key]) {
          hashMap[key].push(complainFormated);
        } else {
          hashMap[key] = [];
          hashMap[key].push(complainFormated);
        }
        formetedRep.push(complainFormated);
      }
      for (let i in hashMap) {
        let a = hashMap[i];
        for (let z = 1; z < a.length; z++) {
          if (a[0].children) {
            a[0].children.push(a[z]);
          } else {
            a[0].serviceName = `${a[0].serviceName} (${a.length} Issue Raised)`;
            a[0].children = [];
            a[0].hasChildren = true;
            a[0].children.push(a[z]);
          }
        }
        check.push(a[0]);
      }

      return check;
    } catch (error) {
      console.log(error);
    }
  };

  remarksUpdate = async obj => {
    let remarksArray = obj.allRemarks ? obj.allRemarks.split("|") : "";
    remarksArray = remarksArray ? remarksArray.filter(obj => obj != "") : "";
    const remarksUpdateObj = {
      allRemarks: remarksArray,
      _id: obj._id,
      serviceId: obj.serviceId
    };
    this.setState({ showRemarksEdit: true, remarksUpdateObj });
  };

  marshallRemarksUpdate = async obj => {
    let allMarshallRemarksArray = obj.allMarshallRemarks
      ? obj.allMarshallRemarks.split("|")
      : "";
    allMarshallRemarksArray = allMarshallRemarksArray
      ? allMarshallRemarksArray.filter(obj => obj != "")
      : "";
    const marshallRemarksUpdateObj = {
      outboundRemark: obj.value,
      allMarshallRemarks: allMarshallRemarksArray,
      raisedBy: obj.raisedBy,
      serviceId: obj.serviceId,
      _id: obj._id
    };
    this.setState({ showMarshallRemarkEdit: true, marshallRemarksUpdateObj });
  };

  marshallCtxShow = async obj => {
    let allCustomerRemarksArray = obj.allCustomerRemarks
      ? obj.allCustomerRemarks.split("|")
      : "";
    allCustomerRemarksArray = allCustomerRemarksArray
      ? allCustomerRemarksArray.filter(obj => obj != "")
      : "";

    const customerRemarkObj = {
      outboundRemark: obj.value,
      allCustomerRemarks: allCustomerRemarksArray,
      raisedBy: obj.raisedBy,
      serviceId: obj.serviceId,
      _id: obj._id
    };

    this.setState({ showCtxRemarks: true, customerRemarkObj });
  };

  updateMarshallRemark = async () => {
    const {
      complainResponse,
      marshallRemarkInput,
      marshallRemarksUpdateObj,
      searchedData
    } = this.state;
    if (marshallRemarkInput.trim().length === 0) {
      message.error("please enter something");
      this.setState({
        showOutBoundsEdit: false,
        marshallRemarkInput: ""
      });
      return;
    }
    let toBeUpdateData = complainResponse.filter(
      comp => comp._id == marshallRemarksUpdateObj._id
    );
    if (toBeUpdateData.length == 0) {
      const serviceBasedFilter = complainResponse.filter(
        comp => comp.serviceId == marshallRemarksUpdateObj.serviceId
      );
      toBeUpdateData = serviceBasedFilter[0].children.filter(
        comp => comp._id == marshallRemarksUpdateObj._id
      );
    }
    const url = `/bus-tracker/complianUpdate`;
    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);

    let remark = toBeUpdateData[0].marshallRemarks.allMarshallRemarks
      ? `${toBeUpdateData[0].marshallRemarks.allMarshallRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}: ${marshallRemarkInput} |`;
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        _id: marshallRemarksUpdateObj._id,
        marshallRemark: updateData,
        raisedBy: toBeUpdateData[0].complainRaisedBy
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData,
        marshallRemarksUpdateObj: {},
        showMarshallRemarkEdit: false,
        marshallRemarkInput: ""
      });
      message.success("Data is updated");
    } else {
      message.success("Data not updated");
      this.setState({
        showMarshallRemarkEdit: false,
        marshallRemarkInput: ""
      });
    }
  };

  solutionTimeUpdate = async obj => {
    const soltimeUpdateObj = {
      tat: obj.value,
      raisedBy: obj.raisedBy,
      _id: obj._id,
      serviceId: obj.serviceId
    };
    this.setState({ showSolutionTimeEdit: true, soltimeUpdateObj });
  };

  showVideoModal = async headCountDetails => {
    const { videoUrl } = headCountDetails;

    this.setState({
      showVideoAttachmentModal: true,
      modalLoader: true,
      videoAttachment: null
    });

    const url = `/workAuditHistory/facialTasksImages`;
    const options = { method: "post", data: { photos: [videoUrl] } };

    const response = await Fetch(url, options);

    this.setState({
      modalLoader: false,
      videoAttachment: response && response.length > 0 ? response[0] : null
    });
  };

  showImageModal = async photos => {
    this.setState({
      showImageModal: true,
      modalLoader: true,
      imageAttachment: []
    });

    const url = `/workAuditHistory/facialTasksImages`;
    const options = { method: "post", data: { photos } };

    const response = await Fetch(url, options);

    this.setState({
      modalLoader: false,
      imageAttachment: response
    });
  };

  showAttachmentModal = async (
    sessionId,
    user_id,
    attachment,
    _id,
    attachmentType,
    driverImages,
    trip
  ) => {
    let type = attachmentType;
    if (sessionId) {
      const photos = [`liveness_images/${user_id}/${sessionId}/reference.jpg`];
      if (trip && trip.busDriver && trip.busDriver.profilePhotoDetails) {
        const verifiedImages = trip.busDriver.profilePhotoDetails.profilePhotos;
        photos.push(...verifiedImages);
      }
      const url = `/workAuditHistory/facialTasksImages`;
      const options = { method: "post", data: { photos } };
      const fetchedAttachment = await Fetch(url, options);
      const verifiedImages = [];
      const liveStreamFaces = [];

      photos.forEach((path, index) => {
        if (path.includes("verified_images/")) {
          verifiedImages.push(fetchedAttachment[index]);
        } else {
          liveStreamFaces.push(fetchedAttachment[index]);
        }
      });

      this.setState({
        showFailedAttachments: true,
        verifiedImages,
        liveStreamFaces
      });
    } else if (driverImages) {
      const photos = driverImages;
      const url = `/workAuditHistory/facialTasksImages`;
      const options = { method: "post", data: { photos } };
      const fetchedAttachment = await Fetch(url, options);

      const verifiedImages = [];
      const liveStreamFaces = [];

      photos.forEach((path, index) => {
        if (path.includes("verified_images/")) {
          verifiedImages.push(fetchedAttachment[index]);
        } else {
          liveStreamFaces.push(fetchedAttachment[index]);
        }
      });

      this.setState({
        showArrayAttachments: true,
        verifiedImages,
        liveStreamFaces,
        attachmentType: type
      });
    }
  };

  showCrewModal = async (
    sessionId,
    trip,
    date,
    _id,
    livenessConfidence,
    similarity
  ) => {
    const crewDetails = {
      sessionId,
      user_id: trip && trip.busDriver ? trip.busDriver._id : "",
      name: trip && trip.busDriver ? trip.busDriver.name : "",
      mobileNo: trip && trip.busDriver ? trip.busDriver.mobileNo : "",
      date,
      _id,
      livenessConfidence,
      similarity
    };
    this.setState({
      showCrewDetailsForFr: true,
      crewDetails
    });
  };

  showFrameModal = async (frames, data) => {
    const photos = frames;
    const url = `/workAuditHistory/facialTasksImages`;
    const options = { method: "post", data: { photos } };
    const fetchedAttachment = await Fetch(url, options);
    const frameImages = fetchedAttachment;
    const matchedImages = data.matchedImages;

    const idsDetails = {
      tripId: data.tripId,
      busRc: data.busRc,
      busDriver:
        data.trip && data.trip.busDriver
          ? ` ${data.trip.busDriver.name} || ${data.trip.busDriver.mobileNo}  || ${data.trip.busDriver._id}`
          : "",
      busHost:
        data.trip && data.trip.busHost
          ? ` ${data.trip.busHost.name} || ${data.trip.busHost.mobileNo}  || ${data.trip.busHost._id}`
          : "",
      messageFromDms: data.messageFromDms
    };

    this.setState({
      showFrames: true,
      idsDetails,
      frameImages,
      matchedImages
    });
  };

  showHeadModal = async data => {
    const url = `/bus-tracker/headCountEvents?tripId=${data.tripId}&stationId=${data.stationId}`;
    const headcountEvents = await Fetch(url, { method: "get" });

    const stationName = data.headCountDetailsTrip?.station
      ? data.headCountDetailsTrip?.station?.name +
        " (" +
        data.headCountDetailsTrip?.station?.city?.name +
        ")"
      : "";
    const idsDetails = {
      start_time: data?.headCountDetailsTrip?.start_time
        ? moment(data.headCountDetailsTrip.start_time).format("LLL")
        : "",
      end_time: data?.headCountDetailsTrip?.end_time
        ? moment(data.headCountDetailsTrip.end_time).format("LLL")
        : "",
      stationId: data.stationId,
      serviceName: data.serviceName,
      dropStationName: data.dropStationName,
      tripName: data.tripId,
      entry: data.entry,
      busRc: data.busRc,
      exit: data.exit,
      expectedCount: data.expectedCount,
      tripId: data.tripId,
      pickupStationName: data.stationName,
      stationName,
      stationTime: data?.stationTime
        ? moment(data.stationTime).format("LLL")
        : "",
      dropStationTime: data?.dropStationTime
        ? moment(data.dropStationTime).format("LLL")
        : ""
    };
    this.setState({
      showHeadDetails: true,
      idsDetails,
      headcountEvents: headcountEvents || []
    });
  };

  showCallModal = async (tripId, _id) => {
    const tripUrl = `/bus-tracker/singleTrip/?tripId=${tripId}`;
    const tripOptions = {
      method: "get"
    };
    let tripResponse = await Fetch(tripUrl, tripOptions),
      marshalObj;
    if (tripResponse) {
      if (!tripResponse.busHost.mobileNo) {
        message.error("Host Not Assigned Yet");
        return;
      }
      marshalObj = {
        _id,
        name: tripResponse.busHost.name,
        service: tripResponse.service.name,
        number: tripResponse.busHost.mobileNo,
        tripDate: moment(parseInt(tripResponse.tripDate)).format("LL")
      };
    }
    this.setState({ marshalObj, showMarshallCall: true });
  };

  showLogsModal = async (tripId, createdOn) => {
    const tripUrl = `/bus-tracker/singleTrip/?tripId=${tripId}`;
    const tripOptions = {
      method: "get"
    };

    let tripResponse = await Fetch(tripUrl, tripOptions);
    if (tripResponse) {
      if (!tripResponse.busHost.mobileNo) {
        message.error("Host Not Assigned Yet");
        return;
      }

      const url = `/bus-tracker/callLogs?number=${tripResponse.busHost.mobileNo}&createdOn=${createdOn}`;
      const options = {
        method: "get"
      };
      let response = await Fetch(url, options);
      if (response.length > 0) {
        let callDetailsObj = [];
        response.forEach(obj => {
          let callData = {
            time: obj.start_time,
            duration: obj.billsec + " s",
            status: obj.status,
            recording: { recording: obj.recording, status: obj.status }
          };

          callDetailsObj.push(callData);

          this.setState({ callDetailsObj, showLogs: true });
        });
      } else {
        message.error("No Logs Found");
      }
    }
  };

  updateStatus = async obj => {
    if (obj && obj.isNotBoarded && obj.status == "CLOSED") {
      let stateObj = {
        faultModal: true,
        faultObj: {
          _id: obj._id,
          status: obj.status,
          faultOf: null
        }
      };
      this.setState(stateObj);
      return;
    }
    const { complainResponse, searchedData } = this.state;
    let url = `/bus-tracker/complianUpdate`;
    let toBeUpdateData = complainResponse.filter(comp => comp._id == obj._id);
    if (toBeUpdateData.length == 0) {
      const serviceBasedFilter = complainResponse.filter(
        comp => comp.serviceId == obj.serviceId
      );
      toBeUpdateData = serviceBasedFilter[0].children.filter(
        comp => comp._id == obj._id
      );
    }

    if (
      toBeUpdateData[0].complainCategory ===
        "NO CALLS MADE 45MINS BEFORE PICKUP" ||
      toBeUpdateData[0].complainCategory ===
        "BILL SEC LESS THAN 15 BEFORE 45 MINS" ||
      toBeUpdateData[0].complainCategory === "NO CALLS CONNECTED BEFORE 45 MINS"
    ) {
      url = `/bus-tracker/complianBulkUpdate`;
    }

    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);
    let remark = toBeUpdateData[0].remarks.allRemarks
      ? `${toBeUpdateData[0].remarks.allRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}:moved from ${toBeUpdateData[0].status.status} to ${obj.status}|`;
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        complainCategory: toBeUpdateData[0].complainCategory,
        _id: obj._id,
        raisedBy: obj.raisedBy,
        status: obj.status,
        remark: updateData
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData
      });
      message.success("Data is updated");
    }
  };

  updateDepartment = async obj => {
    const { complainResponse, searchedData } = this.state;
    const url = `/bus-tracker/complianUpdate`;
    let toBeUpdateData = complainResponse.filter(comp => comp._id == obj._id);
    if (toBeUpdateData.length == 0) {
      const serviceBasedFilter = complainResponse.filter(
        comp => comp.serviceId == obj.serviceId
      );
      toBeUpdateData = serviceBasedFilter[0].children.filter(
        comp => comp._id == obj._id
      );
    }
    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);
    let remark = toBeUpdateData[0].remarks.allRemarks
      ? `${toBeUpdateData[0].remarks.allRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}:moved from ${toBeUpdateData[0].department.department} to ${
      obj.department
    }|`;
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        _id: obj._id,
        raisedBy: obj.raisedBy,
        department: obj.department,
        remark: updateData
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData
      });
      message.success("Data is updated");
    }
  };

  showLoading = () => {
    this.setState({ contentLoading: true });
  };

  updateRemark = async () => {
    const {
      complainResponse,
      remarkInput,
      remarksUpdateObj,
      searchedData
    } = this.state;
    if (remarkInput.trim().length === 0) {
      message.error("please enter something");
      this.setState({
        showRemarksEdit: false,
        remarkInput: ""
      });
      return;
    }
    let toBeUpdateData = complainResponse.filter(
      comp => comp._id == remarksUpdateObj._id
    );
    if (toBeUpdateData.length == 0) {
      const serviceBasedFilter = complainResponse.filter(
        comp => comp.serviceId == remarksUpdateObj.serviceId
      );
      toBeUpdateData = serviceBasedFilter[0].children.filter(
        comp => comp._id == remarksUpdateObj._id
      );
    }
    const url = `/bus-tracker/complianUpdate`;
    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);

    let remark = toBeUpdateData[0].remarks.allRemarks
      ? `${toBeUpdateData[0].remarks.allRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}: ${remarkInput} |`;
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        _id: remarksUpdateObj._id,
        remark: updateData,
        raisedBy: toBeUpdateData[0].complainRaisedBy
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData,
        remarksUpdateObj: {},
        showRemarksEdit: false,
        remarkInput: ""
      });
      message.success("Data is updated");
    } else {
      message.success("Data not updated");
      this.setState({
        showRemarksEdit: false,
        remarkInput: ""
      });
    }
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleTextChange = (key, value) => {
    this.setState({ [key]: value });
  };

  updateTime = async () => {
    const {
      complainResponse,
      soltimeUpdateObj,
      searchedData,
      hours,
      day,
      minutes
    } = this.state;
    const url = `/bus-tracker/complianUpdate`;
    let toBeUpdateData = complainResponse.filter(
      obj => soltimeUpdateObj._id == obj._id
    );
    if (toBeUpdateData.length == 0) {
      const serviceBasedFilter = complainResponse.filter(
        comp => comp.serviceId == soltimeUpdateObj.serviceId
      );
      toBeUpdateData = serviceBasedFilter[0].children.filter(
        comp => comp._id == soltimeUpdateObj._id
      );
    }
    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);
    let newTat = toBeUpdateData[0].tatInMillis
      ? toBeUpdateData[0].tatInMillis
      : 0;

    const newSolTimehr = parseInt(hours) * 60 * 60 * 1000;
    const newSolTimeMin = parseInt(minutes) * 60 * 1000;
    const newSolTimeday = parseInt(day) * 24 * 60 * 60 * 1000;

    const newSolTime = newSolTimehr + newSolTimeMin + newSolTimeday + newTat;

    let remark = toBeUpdateData[0].remarks.allRemarks
      ? `${toBeUpdateData[0].remarks.allRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}: updated solution time ${
      toBeUpdateData[0].tat
    } to ${day} day:${hours} hours:${minutes} minutes |`;
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        _id: soltimeUpdateObj._id,
        tat: newSolTime,
        remark: updateData,
        raisedBy: toBeUpdateData[0].complainRaisedBy
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData,
        showSolutionTimeEdit: false,
        minutes: 0,
        hours: 0,
        day: 0
      });
      message.success("Data is updated");
    } else {
      message.error("something went wrong");
    }
  };
  dayPicker = e => {
    if (e.target.value < 10) {
      this.setState({ day: e.target.value });
    }
  };

  hrPicker = e => {
    if (e.target.value < 24) {
      this.setState({ hours: e.target.value });
    }
  };

  minutesPicker = e => {
    if (e.target.value < 60) {
      this.setState({ minutes: e.target.value });
    }
  };

  call = async () => {
    const { bookingcomplain, marshalObj } = this.state;
    const url = `/bus-tracker/camplainCall`;
    const options = {
      method: "post",
      data: {
        number: marshalObj ? marshalObj.number : bookingcomplain.number
      }
    };
    let response = await Fetch(url, options);
    if (response == "ok") {
      message.success("You will recieve call shortly");
      this.setState({
        showMarshallCall: false,
        marshalObj: []
      });
    } else if (response == "error") {
      message.error("There is some error");
      this.setState({
        showMarshallCall: false,
        marshalObj: []
      });
    }
  };

  updateData = async data => {
    try {
      const url = `/bus-tracker/complianSearch`;
      const options = {
        method: "post",
        data
      };
      const response = await Fetch(url, options);
      if (response && Array.isArray(response)) {
        let formattedData = this.formattedData(response);
        this.setFilterAttributes(formattedData);
        this.setState({
          searchedData: data,
          complainResponse: formattedData,
          contentLoading: false
        });
      } else {
        this.setState({
          complainResponse: [],
          contentLoading: false
        });
      }
    } catch (err) {
      console.log(err);
      this.setState({
        contentLoading: false
      });
      message.error(err);
    }
  };
  handleButtonClick = () => {
    this.setState({
      showMarshallCall: false,
      marshalObj: []
    });
  };
  handleInputChange = e => {
    this.handleTextChange("marshallRemarkInput", e.target.value);
  };

  updateFaultStatus = (key, value) => {
    const { faultObj } = this.state;
    let stateObj = {
      faultObj: {
        ...faultObj,
        [key]: value
      }
    };
    this.setState(stateObj);
  };

  updateFault = async () => {
    const { complainResponse, faultObj, searchedData } = this.state;

    const url = `/bus-tracker/complianUpdate`;
    let toBeUpdateData = complainResponse.filter(
      comp => comp._id == faultObj._id
    );

    const token = localStorage.getItem("idToken");
    const decodedToken = jwtDecode(token);
    let remark = toBeUpdateData[0].remarks.allRemarks
      ? `${toBeUpdateData[0].remarks.allRemarks} `
      : "";

    let updateData = `${remark}${decodedToken.name},${moment().format(
      "LLL"
    )}:fault of ${faultObj.faultOf} & status Moved to ${faultObj.status} |`;

    if (faultObj.status == "CLOSED" && !faultObj.faultOf) {
      message.error("Plese select fault of");
      return;
    }
    const options = {
      method: "patch",
      data: {
        updateBody: searchedData,
        _id: faultObj._id,
        remark: updateData,
        status: faultObj.status,
        raisedBy: toBeUpdateData[0].complainRaisedBy,
        faultOf: faultObj.faultOf,
        resolvedBy: faultObj.status == "CLOSED" ? decodedToken.name : undefined
      }
    };

    const response = await Fetch(url, options);
    if (response && Array.isArray(response)) {
      const formattedData = this.formattedData(response);

      this.setState({
        complainResponse: formattedData,
        faultModal: false,
        faultObj: {}
      });
      message.success("Data is updated");
    }
  };

  handleRemarkInput = e => {
    this.handleTextChange("remarkInput", e.target.value);
  };

  handleRemarkCancel = () => {
    this.setState({
      marshallRemarkInput: "",
      showMarshallRemarkEdit: false
    });
  };

  modalCustomerRemarksCancel = () => {
    this.setState({
      showCtxRemarks: false
    });
  };

  modalRemarksCancel = () => {
    this.setState({
      remarkInput: "",
      showRemarksEdit: false
    });
  };

  modalSolutionTime = () => {
    this.setState({
      showSolutionTimeEdit: false
    });
  };

  handleShowCall = () => {
    this.handleChange("showCall", false);
  };

  handleShowLogs = () => {
    this.handleChange("showLogs", false);
  };

  handleAttachment = () => {
    this.setState({
      showAttachments: false,
      showArrayAttachments: false,
      showFailedAttachments: false,
      showFrames: false,
      attachmentPath: "",
      attachmentType: "",
      liveStreamFaces: [],
      verifiedImages: [],
      frameImages: [],
      filteredMatchedImages: [],
      tableColumns: [],
      idsDetails: {},
      activeKey: "1"
    });
  };

  handleImageError = brokenIndex => {
    this.setState(prevState => ({
      frameImages: prevState.frameImages.filter((_, i) => i !== brokenIndex)
    }));
  };

  copyData = value => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        message.success("copied");
      })
      .catch(err => {
        console.error("Error copying text: ", err);
      });
  };

  handleTabChange = async key => {
    const { matchedImages } = this.state;
    let stateObj = { activeKey: key };

    if (key === "3" && matchedImages && matchedImages.length > 0) {
      const bestMatches = {};
      const newMatchedImages = matchedImages.filter(data => {
        const sim = parseFloat(data.similarity);
        return !isNaN(sim) && sim > 0;
      });

      newMatchedImages.forEach(match => {
        const src = match.source_image;
        const sim = parseFloat(match.similarity.replace("%", ""));

        if (!bestMatches[src] || sim > bestMatches[src].similarity) {
          bestMatches[src] = {
            source_image: { image: src },
            matched_target_image: { image: match.matched_target_image },
            similarity: sim,
            type: src.includes("driver") ? "driver" : "other"
          };
        }
      });

      let filteredMatchedImages = Object.values(bestMatches);

      const photos = filteredMatchedImages.flatMap(data => [
        data.source_image.image,
        data.matched_target_image.image
      ]);

      const url = `/workAuditHistory/facialTasksImages`;
      const options = { method: "post", data: { photos } };

      try {
        const fetchedAttachment = await Fetch(url, options);

        const updatedPhotos = fetchedAttachment || [];

        let idx = 0;
        filteredMatchedImages = filteredMatchedImages.map(img => ({
          ...img,
          source_image: updatedPhotos[idx++],
          matched_target_image: updatedPhotos[idx++]
        }));

        stateObj.filteredMatchedImages = filteredMatchedImages;

        stateObj.tableColumns = [
          {
            title: "Person",
            dataIndex: "type",
            key: "type",
            width: "10%"
          },
          {
            title: "Source Image",
            dataIndex: "source_image",
            key: "source_image",
            width: "10%",
            render: image => (
              <Image
                width={100}
                height={100}
                src={image}
                alt="Matched Target"
              />
            )
          },
          {
            title: "Matched Image",
            dataIndex: "matched_target_image",
            key: "matched_target_image",
            render: image => (
              <Image
                width={100}
                height={100}
                src={image}
                alt="Matched Target"
              />
            ),
            width: "10%"
          },
          {
            title: "Similarity",
            dataIndex: "similarity",
            key: "similarity",
            width: "10%"
          }
        ];
      } catch (err) {
        console.error("API error:", err);
        stateObj.error = "Failed to fetch facial tasks images";
      }
    }

    this.setState(stateObj);
  };

  render() {
    const {
      loading,
      showRemarksEdit,
      showSolutionTimeEdit,
      contentLoading,
      callDetailsObj,
      remarkInput,
      remarksUpdateObj,
      complainResponse,
      showArrayAttachments,
      showFailedAttachments,
      showFrames,
      showHeadDetails,
      showAttachments,
      attachmentType,
      attachmentPath,
      liveStreamFaces = [],
      verifiedImages = [],
      frameImages,
      showLogs,
      idsDetails,
      showCall,
      minutes,
      hours,
      day,
      showMarshallCall,
      faultModal,
      showMarshallRemarkEdit,
      showCtxRemarks,
      marshallRemarksUpdateObj,
      customerRemarkObj,
      marshallRemarkInput,
      marshalObj,
      showCrewDetailsForFr = false,
      crewDetails = {},
      faultObj = {},
      activeKey,
      filteredMatchedImages,
      tableColumns,
      showVideoAttachmentModal,
      modalLoader,
      videoAttachment,
      headcountEvents,
      showImageModal,
      imageAttachment
    } = this.state;

    const headColumns = [
      {
        title: "Serial Number",
        dataIndex: "serial",
        key: "serial"
      },
      {
        title: "Detected Pickup",
        dataIndex: "pickup",
        key: "pickup"
      },
      {
        title: "Detected Drop",
        dataIndex: "drop",
        key: "drop"
      },
      {
        title: "Start Time",
        dataIndex: "startTime",
        key: "startTime"
      },
      {
        title: "End Time",
        dataIndex: "endTime",
        key: "endTime"
      },
      {
        title: "LogId",
        dataIndex: "logId",
        key: "logId",
        width: 180,
        render: logId => {
          if (!logId || logId === "-") return "-";

          const formattedLogId = logId.replace(/-/g, "_"); // or replaceAll

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6
              }}
            >
              <Tooltip title={formattedLogId}>
                <span
                  style={{
                    maxWidth: 120,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block"
                  }}
                >
                  {formattedLogId}
                </span>
              </Tooltip>
              {renderCopy(formattedLogId)}
            </div>
          );
        }
      },
      {
        title: "Video",
        dataIndex: "video",
        key: "video",
        render: (_, record) =>
          record.videoUrl ? (
            <a onClick={() => this.showVideoModal(record)}>View</a>
          ) : (
            "-"
          )
      },

      {
        title: "Entry Faces",
        dataIndex: "entryImages",
        key: "entryImages",
        render: entry =>
          entry && entry.length > 0 ? (
            <a onClick={() => this.showImageModal(entry)}>View</a>
          ) : (
            "-"
          )
      },
      {
        title: "Exit Faces",
        dataIndex: "exitImages",
        key: "exitImages",
        render: exit =>
          exit && exit.length > 0 ? (
            <a onClick={() => this.showImageModal(exit)}>View</a>
          ) : (
            "-"
          )
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status"
      }
    ];

    const renderCopy = value =>
      value ? (
        <Tooltip title="Copy">
          <CopyOutlined
            style={{
              marginLeft: 8,
              cursor: "pointer",
              color: "#1890ff"
            }}
            onClick={() => this.copyData(value)}
          />
        </Tooltip>
      ) : null;

    const totalPickup = headcountEvents.reduce(
      (sum, e) => sum + (e.entry || 0),
      0
    );

    const totalDrop = headcountEvents.reduce(
      (sum, e) => sum + (e.exit || 0),
      0
    );
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div>
          <div>
            <CrewTicketSearch
              showLoader={this.showLoading}
              onSearch={this.updateData}
            />
          </div>
          <div
            style={{
              overflow: "hidden",
              width: "100%",
              height: "100vh"
            }}
          >
            <Table
              scroll={{ y: "60vh", x: "195%" }}
              columns={columns}
              loading={contentLoading}
              pagination={false}
              dataSource={complainResponse}
            />
          </div>
          <Modal
            centered
            title="Attachments"
            visible={showAttachments}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleAttachment}
            onClose={this.handleAttachment}
            footer={null}
          >
            {attachmentType == "image" ? (
              <Image width={200} height={200} src={attachmentPath} />
            ) : (
              <video width="320" height="240" controls>
                <source src={attachmentPath} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </Modal>
          <Modal
            centered
            title="Details"
            visible={showCrewDetailsForFr}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={() => this.setState({ showCrewDetailsForFr: false })}
            footer={null}
          >
            <div>
              <div>
                <span>
                  <b>Session Id: </b>
                  {crewDetails.sessionId}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.sessionId)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>
              <div>
                <span>
                  <b>User Id: </b>
                  {crewDetails.user_id}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.user_id)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>

              <div>
                <span>
                  <b>Driver name: </b>
                  {crewDetails.name}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.name)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>

              <div>
                <span>
                  <b>Mobile No: </b>
                  {crewDetails.mobileNo}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.mobileNo)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>

              <div>
                <span>
                  <b>liveness: </b>
                  {crewDetails.livenessConfidence}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.livenessConfidence)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>
              <div>
                <span>
                  <b>similarity: </b>
                  {crewDetails.similarity}
                </span>
                <img
                  onClick={() => this.copyData(crewDetails.similarity)}
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                  alt="copy"
                />
              </div>
              <div>
                <span>
                  <b>Date: </b>
                  {crewDetails.date}
                </span>
              </div>
            </div>
          </Modal>

          <Modal
            centered
            width={"40%"}
            title="Attachments"
            visible={showFailedAttachments}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleAttachment}
            onClose={this.handleAttachment}
            footer={null}
          >
            {" "}
            {liveStreamFaces && liveStreamFaces.length > 0 ? (
              <>
                <p>Faces</p>
                <br />
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  <Image.PreviewGroup>
                    {liveStreamFaces.map((image, index) => (
                      <Image
                        key={index}
                        width={200}
                        height={200}
                        src={image}
                        style={{ margin: "10px" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </>
            ) : null}
            <br />
            {verifiedImages && verifiedImages.length > 0 ? (
              <>
                <p>Verified Images</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  <Image.PreviewGroup>
                    {verifiedImages.map((image, index) => (
                      <Image
                        key={index}
                        width={200}
                        height={200}
                        src={image}
                        style={{ margin: "10px" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </>
            ) : null}
          </Modal>

          <Modal
            centered
            width={"70%"}
            title="Attachments"
            visible={showArrayAttachments}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleAttachment}
            onClose={this.handleAttachment}
            footer={null}
          >
            {" "}
            {liveStreamFaces && liveStreamFaces.length > 0 ? (
              <>
                <p>Faces</p>
                <br />
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  <Image.PreviewGroup>
                    {liveStreamFaces.map((image, index) => (
                      <Image
                        key={index}
                        width={200}
                        height={200}
                        src={image}
                        style={{ margin: "10px" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </>
            ) : null}
            <br />
            {verifiedImages && verifiedImages.length > 0 ? (
              <>
                <p>Verified Images</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  <Image.PreviewGroup>
                    {verifiedImages.map((image, index) => (
                      <Image
                        key={index}
                        width={200}
                        height={200}
                        src={image}
                        style={{ margin: "10px" }}
                      />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </>
            ) : null}
          </Modal>

          <Modal
            centered
            title="Details"
            visible={showFrames}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleAttachment}
            onClose={this.handleAttachment}
            footer={null}
            width={activeKey === "3" ? "70%" : "50%"}
          >
            <Tabs
              activeKey={activeKey}
              onChange={key => this.handleTabChange(key)}
            >
              <TabPane tab={"Frame Image"} key="1">
                {frameImages.length > 0 ? (
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}
                  >
                    <Image.PreviewGroup>
                      {frameImages.map((image, index) => (
                        <Image
                          key={index}
                          width={200}
                          height={200}
                          src={image}
                          style={{ margin: "10px" }}
                          onError={() => this.handleImageError(index)}
                        />
                      ))}
                    </Image.PreviewGroup>
                  </div>
                ) : (
                  "No frames found"
                )}
              </TabPane>
              <TabPane tab={"Ids and Details"} key="2">
                <div>
                  <div>
                    <span>
                      <b>trip Id: </b>
                      {idsDetails.tripId}
                    </span>{" "}
                    <img
                      onClick={() => this.copyData(idsDetails.tripId)}
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                      alt="copy"
                    />
                  </div>
                  <div>
                    <span>
                      <b>busRc: </b>
                      {idsDetails.busRc}
                    </span>{" "}
                    <img
                      onClick={() => this.copyData(idsDetails.busRc)}
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                      alt="copy"
                    />
                  </div>
                  <div>
                    <span>
                      <b>busDriver: </b>
                      {idsDetails.busDriver}
                    </span>{" "}
                    <img
                      onClick={() => this.copyData(idsDetails.busDriver)}
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                      alt="copy"
                    />
                  </div>
                  <div>
                    <span>
                      <b>busHost: </b>
                      {idsDetails.busHost}
                    </span>{" "}
                    <img
                      onClick={() => this.copyData(idsDetails.busHost)}
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tarcer/copy.svg"
                      alt="copy"
                    />
                  </div>
                  <div>
                    <span>
                      <b>Message: </b>
                      {idsDetails.messageFromDms}
                    </span>{" "}
                  </div>
                </div>
              </TabPane>
              <TabPane tab={"Other Details"} key="3">
                <Table
                  columns={tableColumns}
                  pagination={false}
                  dataSource={filteredMatchedImages}
                />
              </TabPane>
            </Tabs>
          </Modal>

          <Modal
            centered
            title="Video Attachment"
            zIndex={2000}
            width={900}
            style={{ top: 20 }}
            bodyStyle={{ padding: 16, textAlign: "center" }}
            visible={showVideoAttachmentModal}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={() =>
              this.setState({
                modalLoader: false,
                showVideoAttachmentModal: false,
                videoAttachment: ""
              })
            }
            footer={null}
          >
            {modalLoader ? (
              <Loader />
            ) : (
              <video
                key={videoAttachment}
                width="868"
                height="480"
                controls
                style={{
                  maxWidth: "100%",
                  borderRadius: 8
                }}
              >
                <source src={videoAttachment} type="video/mp4" />
              </video>
            )}
          </Modal>

          <Modal
            centered
            title="Images"
            zIndex={2000}
            width={500} // slightly increased for better grid fit
            visible={showImageModal}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={() =>
              this.setState({
                modalLoader: false,
                showImageModal: false,
                imageAttachment: []
              })
            }
            footer={null}
          >
            {modalLoader ? (
              <Loader />
            ) : imageAttachment && imageAttachment.length > 0 ? (
              <div id="image-preview-container">
                <Image.PreviewGroup
                  zIndex={2001}
                  preview={{
                    getContainer: () =>
                      document.getElementById("image-preview-container")
                  }}
                >
                  <Row gutter={[12, 12]}>
                    {imageAttachment.map((img, index) => {
                      const imageName = decodeURIComponent(
                        img
                          .split("?")[0]
                          .split("/")
                          .pop()
                      );
                      return (
                        <Col span={8} key={index}>
                          <Image
                            width="100%"
                            height={120}
                            style={{ objectFit: "cover", borderRadius: 6 }}
                            src={img}
                            alt={imageName}
                          />
                          <div
                            title={imageName}
                            style={{
                              marginTop: 4,
                              fontSize: 12,
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            {imageName}
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Image.PreviewGroup>
              </div>
            ) : (
              <p style={{ textAlign: "center" }}>No images found</p>
            )}
          </Modal>

          <Modal
            centered
            width={"100%"}
            title="Head Details"
            visible={showHeadDetails}
            onCancel={() => this.setState({ showHeadDetails: false })}
            footer={null}
          >
            {/* 🔹 Top Info Section */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "220px 1fr",
                rowGap: "12px",
                columnGap: "12px",
                marginBottom: 20
              }}
            >
              <b>Bus Rc</b>
              <span>
                {idsDetails.busRc || "-"}
                {renderCopy(idsDetails.busRc)}
              </span>

              <b>PickUp Station Name</b>
              <span>{idsDetails.pickupStationName || "-"}</span>

              <b>Pickup Time</b>
              <span>{idsDetails.stationTime || "-"}</span>

              <b>Drop Station Name</b>
              <span>{idsDetails.dropStationName || "-"}</span>

              <b>Drop Time</b>
              <span>{idsDetails.dropStationTime || "-"}</span>

              <b>Trip Name</b>
              <span>
                {idsDetails.serviceName || "-"}
                {renderCopy(idsDetails.serviceName)}
              </span>

              <b>Trip Id</b>
              <span>
                {idsDetails.tripId || "-"}
                {renderCopy(idsDetails.tripId)}
              </span>

              <b>Station </b>
              <span>
                {idsDetails.stationName || "-"}
                {renderCopy(idsDetails.stationName)}
              </span>

              <b>Station Id</b>
              <span>
                {idsDetails.stationId || "-"}
                {renderCopy(idsDetails.stationId)}
              </span>

              {/* <b>Drop Count</b>
              <span>{idsDetails.exit || 0}</span> */}

              <b>Pick Up Count</b>
              <span>{idsDetails.expectedCount || 0}</span>
            </div>

            {/* 🔹 Table Section */}
            <Table
              bordered
              pagination={false}
              scroll={{ x: "120%", y: 400 }}
              columns={headColumns}
              dataSource={[
                ...headcountEvents.map((event, index) => ({
                  key: index,
                  serial: index + 1,
                  pickup: event.entry || 0,
                  drop: event.exit || 0,
                  startTime: event.startTime
                    ? moment(event.startTime).format("h:mm:ss A")
                    : "-",
                  endTime: event.endTime
                    ? moment(event.endTime).format("h:mm:ss A")
                    : "-",
                  logId: event.logId || "-",
                  videoUrl: event.videoUrl,
                  entryImages: event.entryImages,
                  exitImages: event.exitImages,
                  status: event.status || "-"
                })),

                {
                  key: "total",
                  serial: <b>Total</b>,
                  pickup: <b>{totalPickup || 0}</b>,
                  drop: <b>{totalDrop || 0}</b>,
                  startTime: "-",
                  endTime: "-",
                  logId: "-",
                  video: "-",
                  entryImages: undefined,
                  exitImages: undefined,
                  status: "-"
                }
              ]}
            />
          </Modal>

          <Modal
            centered
            width={"100%"}
            title="Call Logs"
            visible={showLogs}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleShowLogs}
            footer={null}
          >
            <Table
              columns={callDetailsCol}
              dataSource={callDetailsObj}
              pagination={false}
              scroll={{ y: 300 }}
            />
          </Modal>
          <Modal
            centered
            width={"100%"}
            title="Call Marshal"
            visible={showCall}
            cancelButtonProps={{ style: { display: "none" } }}
            onCancel={this.handleShowCall}
            footer={null}
          >
            <span>attachment</span>
          </Modal>
          <Modal
            title="Solution Time Update"
            visible={showSolutionTimeEdit}
            okText="Update"
            width={800}
            onOk={this.updateTime}
            onCancel={this.modalSolutionTime}
          >
            <span>Enter day/hrs/mins</span>
            <input
              style={{ margin: "10px 10px" }}
              value={day}
              type="number"
              placeholder="please enter day"
              onChange={this.dayPicker}
            ></input>
            <input
              style={{ margin: "10px 10px" }}
              value={hours}
              type="number"
              placeholder="please enter hrs"
              onChange={this.hrPicker}
            ></input>
            <input
              value={minutes}
              type="number"
              placeholder="please enter mins"
              onChange={this.minutesPicker}
            ></input>
          </Modal>
          <Modal
            title="Remarks"
            visible={showRemarksEdit}
            okText="Update"
            onOk={this.updateRemark}
            onCancel={this.modalRemarksCancel}
          >
            {remarksUpdateObj && Array.isArray(remarksUpdateObj.allRemarks)
              ? remarksUpdateObj.allRemarks.map(text => {
                  return (
                    <div key={text}>
                      <p>{text}</p>
                    </div>
                  );
                })
              : null}

            <Input
              value={remarkInput}
              placeholder="Enter Remark"
              onChange={this.handleRemarkInput}
            />
          </Modal>
          <Modal
            title="Customer Remarks"
            visible={showCtxRemarks}
            footer={null}
            onCancel={this.modalCustomerRemarksCancel}
          >
            {customerRemarkObj &&
            Array.isArray(customerRemarkObj.allCustomerRemarks)
              ? customerRemarkObj.allCustomerRemarks.map((text, index) => {
                  return (
                    <div key={index}>
                      <p>{text}</p>
                    </div>
                  );
                })
              : null}
          </Modal>
          <Modal
            title="Marshal Remarks"
            visible={showMarshallRemarkEdit}
            okText="Update"
            onOk={this.updateMarshallRemark}
            onCancel={this.handleRemarkCancel}
          >
            {marshallRemarksUpdateObj &&
            Array.isArray(marshallRemarksUpdateObj.allMarshallRemarks)
              ? marshallRemarksUpdateObj.allMarshallRemarks.map(
                  (text, index) => {
                    return (
                      <div key={index}>
                        <p>{text}</p>
                      </div>
                    );
                  }
                )
              : null}

            <Input
              value={marshallRemarkInput}
              placeholder="Enter Remark"
              onChange={this.handleInputChange}
            />
          </Modal>
          <Modal
            title=" Marshal Details"
            visible={showMarshallCall}
            centered
            onCancel={this.handleButtonClick}
            closable={false}
            okButtonProps={{ style: { display: "none" } }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <div>
              <p>
                Marshal Name:{" "}
                <b
                  style={{
                    fontSize: "15px"
                  }}
                >
                  {" "}
                  {marshalObj ? marshalObj.name : ""}
                </b>
              </p>
              <p>
                {" "}
                Service:{" "}
                <b
                  style={{
                    fontSize: "15px"
                  }}
                >
                  {" "}
                  {marshalObj ? marshalObj.service : ""}
                </b>
              </p>
              <p>
                Trip Date:{" "}
                <b
                  style={{
                    fontSize: "15px"
                  }}
                >
                  {" "}
                  {marshalObj ? marshalObj.tripDate : ""}
                </b>
              </p>
            </div>
            <b
              style={{
                fontSize: "15px"
              }}
            >
              {" "}
              Are you sure you want to place a Call to the Marshal ?
            </b>
            <div
              style={{
                marginTop: "5px",
                display: "flex",
                justifyContent: "center"
              }}
            >
              <Button
                type="primary"
                onClick={this.call}
                style={{ marginRight: "5px" }}
              >
                Call
              </Button>
              <Button
                onClick={this.handleButtonClick} // Pass the method as reference
                type="ghost"
              >
                Cancel
              </Button>
            </div>
          </Modal>
          <Modal
            title="FAULT ATTRIBUTION "
            visible={faultModal}
            okText="Save"
            onOk={this.updateFault}
            onCancel={() =>
              this.setState({
                faultModal: false,
                faultObj: {}
              })
            }
          >
            <div>
              <span>Fault of </span>{" "}
              <Radio.Group
                onChange={e =>
                  this.updateFaultStatus("faultOf", e.target.value)
                }
                value={faultObj.faultOf}
              >
                <Radio value={"Crew"}>Crew</Radio>
                <Radio value={"Traveler"}>Traveler</Radio>
              </Radio.Group>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default complainView;
